<!-- Layer 1: Gradient (outermost) -->
<div class="layout-wrapper" [ngClass]="enableStudentThemes ? layoutThemeClass : ''">
  <div *ngIf="enableStudentThemes && themeName === 'mango'" class="mango-outer-leaf" aria-hidden="true"></div>
  <div *ngIf="enableStudentThemes && themeName === 'mango'" class="mango-top-right-decor" aria-hidden="true">
    <div class="mango-top-right-leaf"></div>
    <div class="mango-top-right-fruit"></div>
  </div>
  <!-- Layer 2: Gray frame (middle) -->
  <div class="layout-gray-frame">
    <div class="layout-decor" aria-hidden="true" *ngIf="enableStudentThemes && (showScienceDecor || themeName === 'rainbow')">
      <div class="layout-cloud layout-cloud-left"></div>
      <div class="layout-formula" *ngIf="showScienceDecor && isDarkTheme()"></div>
    </div>

    <!-- Top header bar - icons left, profile right (Figma, custom theme only) -->
    <header class="layout-top-header" *ngIf="isCustomTheme || enableStudentThemes">
      <div class="header-left">
        <img src="assets/ScholarX_Logo_Icon.svg" alt="ScholarX" class="header-logo" />
        <img *ngIf="user?.user?.theme?.logo" [src]="user.user.theme.logo" alt="School" class="header-school-logo" />
      </div>
      <div class="header-controls">
        <button *ngIf="enableStudentThemes && isJuniorClassStudent()" class="theme-picker-trigger" type="button" (click)="openThemePopup()"
          aria-label="Open theme selector">
          <span class="theme-badge" [ngClass]="themeBadgeClass"></span>
        </button>

        <button *ngIf="enableStudentThemes && isCustomTheme" class="theme-switch" type="button" (click)="toggleTheme()" [attr.aria-pressed]="isDarkTheme()"
          [attr.aria-label]="isDarkTheme() ? 'Switch to light theme' : 'Switch to dark theme'">
          <span class="theme-switch-track">
            <span class="theme-switch-thumb" [class.is-dark]="isDarkTheme()"></span>
          </span>
          <span class="theme-switch-label">{{ isDarkTheme() ? 'Dark' : 'Light' }}</span>
        </button>

        <div class="header-right" (click)="goToProfile()">
          <div *ngIf="!user?.user?.photo" class="header-profile-circle" [style.background-color]="primaryColor || '#5d3e8c'">
            {{ getInitials(user?.user?.name) }}
          </div>
          <img *ngIf="user?.user?.photo" [src]="user.user.photo" alt="Profile" class="header-profile-img" />
        </div>
      </div>
    </header>
    <!-- Layer 3: White panels container -->
    <div class="layout-container">
      <app-sidebar [class.collapsed]="!isSidebarOpen" (newChatRequested)="onNewChatRequested()"
        (closeSidebar)="toggleSidebar()" (chatSelected)="onChatSelected($event)"></app-sidebar>

  <div class="main-content">
    <router-outlet></router-outlet>
  </div>

  <!-- <app-notes-sidebar [class.collapsed]="!isSidebarOpen" (newChatRequested)="onNewChatRequested()"
    (closeSidebar)="toggleSidebar()"></app-notes-sidebar> -->

      <app-notes-sidebar [class.collapsed]="!isNotesSidebarOpen" (newChatRequested)="onNewChatRequested()"
        (closeSidebar)="toggleNotesSidebar()"></app-notes-sidebar>
    </div>
  </div>
</div>

<div class="theme-popup-backdrop" *ngIf="enableStudentThemes && showThemePopup" (click)="closeThemePopup()">
  <div class="theme-popup" (click)="$event.stopPropagation()">
    <div class="theme-popup-title">Select your profile Theme</div>

    <div class="theme-popup-options">
      <button
        *ngFor="let option of juniorThemeOptions"
        type="button"
        class="theme-option"
        [class.is-selected]="pendingThemeName === option.key"
        (click)="selectPopupTheme(option.key)">
        <span class="theme-badge" [ngClass]="option.badgeClass"></span>
      </button>
    </div>

    <div class="theme-popup-actions">
      <button type="button" class="theme-popup-btn save" (click)="saveSelectedTheme()">Save</button>
      <button type="button" class="theme-popup-btn cancel" (click)="closeThemePopup()">Cancel</button>
    </div>
  </div>
</div>
